import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import UserReducer from './UserReducer';
import ForecastReducer from './ForecastReducer';

export default combineReducers({
  router: routerReducer,
  user: UserReducer,
  forecast: ForecastReducer,
});
